module.exports = __webpack_public_path__ + "img/contact.f9aa5f86.svg";